exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-sticky {\n  position: sticky;\n  z-index: 10;\n}\n", ""]);

// exports
